/**
 * PaymentPageWrapper - Feature flag wrapper for Payment Page V2
 *
 * Conditionally renders the new PaymentPageV2 or legacy PPRAPaymentPage
 * based on the IsPaymentPageV2Enabled feature flag.
 *
 * Shows a minimal loading state while feature flags are being fetched
 * to prevent flashing the old page before switching to V2.
 */

import { FeatureFlags, useFeatureFlags } from '@/services/feature-flag-provider';
import { PPRAPaymentPage } from '@/app/components/ppra/components/ppra-payment-page/PPRAPaymentPage';
import { PaymentPageV2 } from './PaymentPageV2';

/**
 * PPRAPaymentPageWrapper - Wraps the entire payment page route
 * When V2 is enabled, renders PaymentPageV2 directly (no children/Outlet)
 * When V2 is disabled, renders legacy PPRAPaymentPage with Outlet for children
 */
export function PPRAPaymentPageWrapper() {
  const { isEnabled, isLoading } = useFeatureFlags();

  // Show blank white screen while feature flags are loading
  // This prevents flashing the old page before V2 is rendered
  if (isLoading) {
    return <div className="min-h-screen bg-white" />;
  }

  const showV2 = isEnabled(FeatureFlags.IsPaymentPageV2Enabled);

  if (showV2) {
    // PaymentPageV2 is self-contained, no need for Outlet
    return <PaymentPageV2 />;
  }

  // Legacy flow uses PPRAPaymentPage which renders Outlet for child routes
  return <PPRAPaymentPage />;
}

export default PPRAPaymentPageWrapper;
